import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import apiClient from "../api/apiClient";

/**
 * Aviso global: si no se cargó la cotización del día, muestra una barra de
 * advertencia en todas las páginas para no operar (facturar) sin ese dato.
 *
 * Se apoya en GET /tipo-cambio/estado-hoy. Si el backend no responde o no hay
 * monedas conocidas todavía, no muestra nada (no molesta en instalaciones
 * nuevas).
 */
const TipoCambioBanner = () => {
  const [estado, setEstado] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const res = await apiClient.get("/tipo-cambio/estado-hoy");
        if (alive) setEstado(res?.data || null);
      } catch {
        if (alive) setEstado(null);
      }
    };
    load();
    // Revalida cada 5 min por si la cargan mientras la app está abierta.
    const t = setInterval(load, 5 * 60 * 1000);
    return () => {
      alive = false;
      clearInterval(t);
    };
  }, []);

  if (!estado || estado.cargado || !(estado.faltantes?.length > 0)) return null;

  return (
    <div className="alert alert-warning border-0 rounded-0 mb-0 py-2 text-center" role="alert">
      <strong>Atención:</strong> no se cargó la cotización de hoy ({estado.fecha}) para{" "}
      <strong>{estado.faltantes.join(", ")}</strong>. No se podrán emitir facturas en esas monedas.{" "}
      <Link to="/tipo-cambio" className="alert-link">
        Cargar tipo de cambio
      </Link>
    </div>
  );
};

export default TipoCambioBanner;
